import React from "react";
import "../css/FeesCard.css";

export default function FeesCard({ title, subtitle, onClick }) {
  return (
    <div className="card" onClick={onClick}>
      <p className="title" style={{ color: "white" }}>
        {title}
      </p>
      <p className="subtitle">{subtitle}</p>
    </div>
  );
}
